import Home from "@/pages/Home";

// HP2 — exact duplicate of the live homepage (HP1). Kept as its own route
// so it can diverge later; for now it renders the same Home composition.
export default function Hp2() {
  return <Home marquee />;
}
